import script from "./company-suspended.vue?vue&type=script&setup=true&lang=js"
export * from "./company-suspended.vue?vue&type=script&setup=true&lang=js"

import "./company-suspended.vue?vue&type=style&index=0&id=9aa67136&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa67136"]])

export default __exports__